import { Typography, Card } from 'antd'

const { Title } = Typography

const TiresPage = () => {
  return (
    <div>
      <Title level={2}>Pneumatici</Title>
      <Card>
        <p>Gestione pneumatici - In sviluppo</p>
      </Card>
    </div>
  )
}

export default TiresPage
